import {
    Breadcrumbs as MantineBreadcrumbs,
    BreadcrumbsProps as MantineBreadcrumbsProps,
} from '@mantine/core';
import { ChevronRight } from '../../icons';

import breadcrumbStyles from './Breadcrumbs.module.css';
import { FC } from 'react';
import { joinClassNames } from '../../utils/joinClassNames';

export type BreadcrumbsProps = MantineBreadcrumbsProps;

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ className, ...props }) => {
    return (
        <MantineBreadcrumbs
            separator={<ChevronRight />}
            className={joinClassNames(breadcrumbStyles.root, className)}
            {...props}
        />
    );
};
